import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import { useModal } from "../contexts/ModalContext";
import Metas from "../Modulos/Checklist/Metas/Metas";

const ChecklistMetas = () => {

    const { openModal } = useModal();

    const abrirMenuLateral = () => {

        openModal("sidebarChecklistMetas");

    }

    return(
        <>
            <NavBar title="METAS CHECKLIST" setSideBar={ abrirMenuLateral } prevDest="./../../modulo/ssma/check-list/" />
            <GenericBody>
                <Metas />
            </GenericBody>
        </>
    )
}

export default ChecklistMetas;